module.exports = __webpack_public_path__ + "img/header_background.0554c753.png";